import { useAppSelector } from 'hooks/useAppSelector';
import {
  ConnectedInsightsItem,
  ConnectedUnderlyingUniverseItem,
} from 'layouts/main/sp-header/navigation/explore-items';
import { NavigationDropdown } from 'layouts/main/sp-header/navigation/NavigationDropdown';
import { createSelector } from 'reselect';
import type { RoutePath } from 'state/router';
import { isDiscoverPageVisible, isUnderlyingUniverseVisible } from 'state/selectors/common/router';

const isVisibleSelector = createSelector(
  isDiscoverPageVisible,
  isUnderlyingUniverseVisible,
  (isDiscoverPage, isUnderlyingUniverse) => isDiscoverPage || isUnderlyingUniverse,
);

const associatedRoutes: RoutePath[] = ['/home', '/underlying-universe'];

export function ExploreMenu() {
  const isVisible = useAppSelector(isVisibleSelector);

  return (
    <NavigationDropdown
      associatedRoutes={associatedRoutes}
      isVisible={isVisible}
      e2e="explore-menu"
      toggleE2e="explore-dropdown-toggle"
      menuE2e="explore-dropdown-menu"
      label="appHeader.navigation.explore"
    >
      <ConnectedInsightsItem />
      <ConnectedUnderlyingUniverseItem />
    </NavigationDropdown>
  );
}
